import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div<{ $loading?: boolean }>`
  position: relative;
  width: 100vw;
  ${({ $loading }) => ($loading ? 'pointer-events: none;' : '')};
`;

export const Img = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const Count = styled(Typography.Caption).attrs({ $variant: '1' })`
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 1;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.overlay['40']};
  padding: 5px 15px;
  letter-spacing: -1.2px;
  color: ${({ theme }) => theme.palette.system.white};
`;
